import { render, staticRenderFns } from "./OrderPurchaseNew.vue?vue&type=template&id=61b77e46"
import script from "./OrderPurchaseNew.vue?vue&type=script&lang=js"
export * from "./OrderPurchaseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports